var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<cart-creditcard-payfabric retailer-id=\"{{$ctrl.retailerId}}\"></cart-creditcard-payfabric>>";
var id1="cart-creditcard-payfabric-prompt.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;